export const GET_PROCESSING_FEES_PATH = '/v2/processing-fees';
